<div class="fondo">
  <cgw-main-banner-section></cgw-main-banner-section>
  <cgw-highlighted-products-section></cgw-highlighted-products-section>
  <cgw-atp-banner-section></cgw-atp-banner-section>
  @if (isExperimentalDev || isValidDateNvidia()) {
    <cgw-nvidia-section></cgw-nvidia-section>
  }
  @if (isExperimentalDev || isValidDatePricesBomb()) {
    <cgw-bomb-prices></cgw-bomb-prices>
  }
  <cgw-categories-section></cgw-categories-section>
  <cgw-offers-section></cgw-offers-section>
  <cgw-additional-section></cgw-additional-section>
  <cgw-primary-banner-section></cgw-primary-banner-section>
  <cgw-latest-news-section></cgw-latest-news-section>
  <cgw-secondary-banner-section></cgw-secondary-banner-section>
  <cgw-brands-section></cgw-brands-section>
</div>
